import React from 'react';
import styles from './JurorVoteCountBanner.module.scss';
import useJuryStore from '../../../store/juryStore';
import { useJuryFundingOptions } from '../../../store/configStore';
import JuryBadge from '../JuryBadge/JuryBadge';

/**
 * JurorVoteCountBanner - Sticky header component for Jury views.
 * Shows how many funding slots have been assigned out of the total available.
 */
const JurorVoteCountBanner = ({ isAuthenticated }) => {
    const poll = useJuryStore((s) => s.poll);
    const isConfirmed = useJuryStore((s) => s.isConfirmed);
    const fundingOptions = useJuryFundingOptions();

    const assignedCount = Object.keys(poll).length;
    const totalCount = fundingOptions.length;
    const remainingCount = totalCount - assignedCount;

    const bannerClasses = [styles.JurorVoteCountBanner, isConfirmed ? styles.JurorVoteCountBannerConfirmed : '']
        .filter(Boolean)
        .join(' ');

    const textClasses = [styles.BannerText, isConfirmed ? 'text-white-no-contrast-preference' : '']
        .filter(Boolean)
        .join(' ');

    return (
        <div id="juror-vote-count-banner" className={bannerClasses} role="status" aria-live="polite">
            <div className={textClasses}>
                {isAuthenticated ? (
                    isConfirmed ? (
                        <>Ihre Förderungsvergabe wurde erfolgreich bestätigt.</>
                    ) : (
                        <>
                            Noch <JuryBadge>{remainingCount}</JuryBadge> von {totalCount} Teilnehmer fördern
                        </>
                    )
                ) : (
                    <>Bitte melden Sie sich an, um fortzufahren</>
                )}
            </div>
        </div>
    );
};

export default JurorVoteCountBanner;
